import { render, staticRenderFns } from "./vertify.vue?vue&type=template&id=5d38cfc2"
import script from "./vertify.vue?vue&type=script&lang=js"
export * from "./vertify.vue?vue&type=script&lang=js"
import style0 from "./vertify.vue?vue&type=style&index=0&id=5d38cfc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports